import {
  FETCH_HOLIDAYS,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  CREATE_HOLIDAY,
  CREATE_HOLIDAY_SUCCESS,
  CREATE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  FETCH_HOLIDAY_EMPLOYEE,
  SAVE_HOLIDAY_PROCESS,
  REMOVE_EMPLOYEE_HOLIDAY,
  FETCH_HOLIDAY_EMPLOYEE_SUCCESS,
  SAVE_HOLIDAY_PROCESS_SUCCESS,
  REMOVE_EMPLOYEE_HOLIDAY_SUCCESS,
  FETCH_HOLIDAY_EMPLOYEE_FAILURE,
  SAVE_HOLIDAY_PROCESS_FAILURE,
  REMOVE_EMPLOYEE_HOLIDAY_FAILURE,
  RESET_HOLIDAY_EMPLOYEES,
  FETCH_HOLIDAY_PROCESS_LIST_REQUEST,
  FETCH_HOLIDAY_PROCESS_LIST_SUCCESS,
  FETCH_HOLIDAY_PROCESS_LIST_FAILURE
} from "./actionTypes";

const initialState = {
  holidays: [],
  holidayEmployees: [],
  holidayProcess: [],
  loading: false,
  error: null,
  success:false
};

const holidayReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_HOLIDAYS:
      return { ...state, loading: true };
    case FETCH_HOLIDAYS_SUCCESS:
      return { ...state, loading: false, holidays: action.payload.data};
    case FETCH_HOLIDAYS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_HOLIDAY:
      return { ...state, loading: true, success:false, error: null };
    case CREATE_HOLIDAY_SUCCESS:
      return {
        ...state, loading: false, success:true, holiday: action.payload, error: null };
    case CREATE_HOLIDAY_FAILURE:
      return { ...state, loading: false, sucess: false, error: action.payload };

    case UPDATE_HOLIDAY:
      return { ...state, loading: true,success:false };
    case UPDATE_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true
      };
    case UPDATE_HOLIDAY_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    case DELETE_HOLIDAY:
      return { ...state, loading: true,success:false };
    case DELETE_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true,
      };
    case DELETE_HOLIDAY_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };
    
    case FETCH_HOLIDAY_EMPLOYEE:
    case SAVE_HOLIDAY_PROCESS:
    case REMOVE_EMPLOYEE_HOLIDAY:
      return { ...state, loading: true, error: null,success:false };

    case FETCH_HOLIDAY_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, holidayEmployees: action.payload?.data,success:false };

    case SAVE_HOLIDAY_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true,
      };

    case REMOVE_EMPLOYEE_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true,
      };

    case FETCH_HOLIDAY_EMPLOYEE_FAILURE:
    case SAVE_HOLIDAY_PROCESS_FAILURE:
    case REMOVE_EMPLOYEE_HOLIDAY_FAILURE:
      return { ...state, loading: false, error: action.error,success:false };

    case RESET_HOLIDAY_EMPLOYEES:
    return {
      ...state,
      holidayEmployees: [],
    };

    case FETCH_HOLIDAY_PROCESS_LIST_REQUEST:
      return { ...state, loading: true, error: null,success:false };
    case FETCH_HOLIDAY_PROCESS_LIST_SUCCESS:
      return { ...state, loading: false, holidayProcess: action.payload?.data,success:false };
    case FETCH_HOLIDAY_PROCESS_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };

    default:
      return state;
  }
};

export default holidayReducer;
